module.exports = __webpack_public_path__ + "img/xmark.02bc832e.svg";